export default __webpack_public_path__ + "static/starclose-932aef875f46b03d85b3786dd9ac82dc.png";